import React from "react";
import "react-phone-input-2/lib/style.css";
import FormHeader from "../../../Common/components/templates/formHeader";
import FormDirections from "../../../Common/components/templates/formDirections";
import { FormattedMessage, useIntl } from "react-intl";

const ResetSuccessful = (props: any) => {    

    return (
        <form className="form">
            <FormHeader title={ useIntl().messages["mfa.resetsuccessful.header"]} />
            <div className="content">
                <FormDirections>
                    <FormattedMessage id="mfa.resetsuccessful.description"></FormattedMessage>
                </FormDirections>
            </div>
        </form>
    );
};

export default ResetSuccessful;
